module.exports = __webpack_public_path__ + "static/media/team5.a40000ae.jpg";